// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class U32 implements flatbuffers.IUnpackableObject<U32T> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): U32 {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsU32(bb: flatbuffers.ByteBuffer, obj?: U32): U32 {
    return (obj || new U32()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsU32(bb: flatbuffers.ByteBuffer, obj?: U32): U32 {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new U32()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startU32(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt32(0, value, 0);
  }

  static endU32(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createU32(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    U32.startU32(builder);
    U32.addValue(builder, value);
    return U32.endU32(builder);
  }

  unpack(): U32T {
    return new U32T(this.value());
  }

  unpackTo(_o: U32T): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): U32T {
    const t = new U32T();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class U32T implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return U32.createU32(builder, this.value);
  }

  clone(): U32T {
    const obj = new U32T();
    obj.value = this.value;
    return obj;
  }

  equals(other: U32T): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyU32(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
